import { Box, Button } from "@mui/material";
import { Modal } from "../common/index.js";

const Confirm = ({ message, open, close, submit, type = "error" }) => {
  return (
    <Modal title={message} open={open} close={close}>
      <Box sx={{ justifyContent: "space-between", display: "flex", gap: 1 }}>
        <Button color="error" variant="outlined" onClick={() => close()}>
          انصراف
        </Button>
        <Button variant="contained" onClick={() => submit()}>
          ثبت اطلاعات
        </Button>
      </Box>
    </Modal>
  );
};

export default Confirm;
